import Row from 'react-bootstrap/Row';

export default function returnHeader(stage, signInType) {
    const mpn = "mobile phone number.";
    const headerMap = {
        EMAIL: "email address.",
        PHONE: mpn,
        OTP: mpn,
        VERIFY: {
            EMAIL: "email address.",
            PHONE: mpn,
        },
        RESET: {
            EMAIL: "email address to reset your password.",
            PHONE: "mobile phone number to reset your password."
        }
    };

    let message;

    if (stage === "VERIFY") {
        message = headerMap.VERIFY?.[signInType];
    }
    else if (stage === "RESET") {
        message = headerMap.RESET?.[signInType];
    }
    else {
        message = headerMap[stage];
    }
    if (!message) {
        return null;
    }

    return (
        <div>
            <Row className="justify-content-center">
                <div className="message__TO left">We have sent you a 6-digit temporary access code to your {message}</div>
            </Row>
        </div>
    );
}